import React, { Component } from "react";
import logo from "../../images/homeLoad.png";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { post } from "../../utils/sysAxios";

class ApplicationInfo extends Component {
  state = {
    inModalMode: true,
    modalHeader: "About System",
    modalSubmitButtonlabel: "Close",
    modalSubmitButtonIcon: "fa fa-check",
    modalWidth: "35vw",
    version: "",
  };

  componentDidMount() {
    this.setState({ inModalMode: this.props.inModalMode });

    post("/api/system/getversion", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ version: apiResponse.data.respData.AppVersion });
      }
    );
  }

  closeModal() {
    this.setState({ inModalMode: false });
    window.location.replace("/dashboard/home");
  }

  render() {
    return (
      <React.Fragment>
        <div className="home-logo text-center">
          <img src={logo} width={700} height={500} alt="System Logo" />
        </div>
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          headerStyle={{ "background-color": "#F0F0F0", color: "black" }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={<h5 className="modal-header">{this.state.modalHeader}</h5>}
          footer={
            <div>
              <Button
                label="Ok"
                icon={this.state.modalSubmitButtonIcon}
                className="p-button-secondary"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <div className="app-info">
            Points Calculation System
            <br /> Version: {this.state.version}
            <br /> [{new Date().getFullYear()}]&nbsp;
            <span>
              &nbsp;All rights reserved &nbsp; Powered By <b>CodeMap</b>
            </span>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default ApplicationInfo;
